export const EVENT_TYPE_DESCRIPTIONS = {
  'COMPLEANNO': 'Compleanno',
  'GRUPPO': 'Gruppo / Condominio',
  'SALONE': 'Salone'
}